import { AddressBadge } from '@/components/molecules'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { useAccount, useDisconnect } from 'wagmi'

export const AccountModal = ({ ...props }) => {
  const { disconnect } = useDisconnect()
  const { address, connector } = useAccount()

  const handleLogout = () => {
    disconnect()

    props.onClose()
  }

  return (
    <>
      <Modal isCentered {...props}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Account</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <Text>Connected via {connector?.name}</Text>
            <AddressBadge
              w={'100%'}
              symbols={10}
              address={address}
              withCopy={true}
            />
          </ModalBody>

          <ModalFooter>
            <Button variant={'soft'} colorScheme="red" onClick={handleLogout}>
              Disconnect
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
